// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1mBKo","modalForm":"UpgradeEpcsModal_modalForm__7jBkC","modalFooter":"UpgradeEpcsModal_modalFooter__1RzPt"};